[
    {
        "countryName": "Afghanistan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Albania",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Algeria",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "American Samoa",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Andorra",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "Angola",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Anguilla",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Antarctica",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "Antigua and Barbuda",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Argentina",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "Armenia",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Aruba",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Australia",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Austria",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "Azerbaijan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Bahamas",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Bahrain",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Bangladesh",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Barbados",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Belarus",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "Belgium",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Belize",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Benin",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Bermuda",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Bhutan",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Bolivia",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "Bosnia and Herzegovina",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Botswana",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Bouvet Island",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "Brazil",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "British Indian Ocean Territory",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Brunei Darussalam",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Bulgaria",
        "supportEmail": "luminasupport.bulgaria@dnv.com"
    },
    {
        "countryName": "Burkina Faso",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Burundi",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Cambodia",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Cameroon",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Canada",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Cape Verde",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Cayman Islands",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Central African Republic",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Chad",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Chile",
        "supportEmail": "luminasupport.chile@dnv.com"
    },
    {
        "countryName": "China",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "Christmas Island",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Cocos (Keeling) Islands",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Colombia",
        "supportEmail": "luminasupport.chile@dnv.com"
    },
    {
        "countryName": "Comoros",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Congo",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Congo, The Democratic Republic",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Cook Islands",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Costa Rica",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Cote D'ivoire",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Croatia",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Cuba",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Curacao",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Cyprus",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Czech Republic",
        "supportEmail": "luminasupport.czsk@dnv.com"
    },
    {
        "countryName": "Denmark",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "Djibouti",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Dominica",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Dominican Republic",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "East Timor",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Ecuador",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Egypt",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "El Salvador",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Equatorial Guinea",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Eritrea",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Estonia",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "Ethiopia",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Falkland Islands (Malvinas)",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "Faroe Islands",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "Fiji",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Finland",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "France",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "France, Metropolitan",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "French Guiana",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "French Polynesia",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "French Southern Territories",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Gabon",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Jersey",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Gambia",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Georgia",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Germany",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "Ghana",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Gibraltar",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Greece",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Greenland",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "Grenada",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Guadeloupe",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Guam",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Guatemala",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Guernsey",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Guinea",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Guinea-bissau",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Guyana",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Haiti",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Heard and Mc Donald Islands",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Holy See (Vatican City State)",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Honduras",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Hong Kong",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "Hungary",
        "supportEmail": "luminasupport.hungary@dnv.com"
    },
    {
        "countryName": "Iceland",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "India",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Indonesia",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Iran (Islamic Republic of)",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Iraq",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Ireland",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Isle of Man",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Israel",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Italy",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Jamaica",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Japan",
        "supportEmail": "luminasupport.japan@dnv.com"
    },
    {
        "countryName": "Jordan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Kazakhstan",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "Kenya",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Kiribati",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Korea",
        "supportEmail": "luminasupport.korea@dnv.com"
    },
    {
        "countryName": "Korea, Democratic People's Rep",
        "supportEmail": "luminasupport.korea@dnv.com"
    },
    {
        "countryName": "Kuwait",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Kyrgyzstan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Lao People's Democratic Republ",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Latvia",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "Lebanon",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Lesotho",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Liberia",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Libyan Arab Jamahiriya",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Liechtenstein",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Lithuania",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "Luxembourg",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Macau",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "Macedonia, The Former Yugoslav",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Madagascar",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Malawi",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Malaysia",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Maldives",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Mali",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Malta",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Marshall Islands",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Martinique",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Mauritania",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Mauritius",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Mayotte",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Mexico",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Micronesia, Federated States o",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Moldova, Republic of",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "Monaco",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Mongolia",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "Montenegro",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Montserrat",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Morocco",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Mozambique",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Myanmar",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Namibia",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Nauru",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Nepal",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "Netherlands",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Caribbean Netherlands",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "New Caledonia",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "New Zealand",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Nicaragua",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Niger",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Nigeria",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Niue",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Norfolk Island",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Northern Mariana Islands",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Norway",
        "supportEmail": "luminasupport.norway@dnv.com"
    },
    {
        "countryName": "Oman",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Pakistan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Palestine",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Palau",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Panama",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "Papua New Guinea",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Paraguay",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Peru",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Philippines",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Pitcairn",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Poland",
        "supportEmail": "luminasupport.poland@dnv.com"
    },
    {
        "countryName": "Portugal",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "Puerto Rico",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Qatar",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Reunion",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Romania",
        "supportEmail": "luminasupport.romania@dnv.com"
    },
    {
        "countryName": "Russian Federation",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "Rwanda",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Saint Kitts and Nevis",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Saint Lucia",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Saint Vincent and the Grenadin",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Samoa",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "San Marino",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Sao Tome and Principe",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Saudi Arabia",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Senegal",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Serbia",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Seychelles",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Sierra Leone",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Singapore",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Slovakia (Slovak Republic)",
        "supportEmail": "luminasupport.czsk@dnv.com"
    },
    {
        "countryName": "Slovenia",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "Solomon Islands",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Somalia",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "South Africa",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "South Georgia and the South Sa",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Spain",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "Sri Lanka",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "St. Helena",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "St. Pierre and Miquelon",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Sudan",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Suriname",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Svalbard and Jan Mayen Islands",
        "supportEmail": "luminasupport.norway@dnv.com"
    },
    {
        "countryName": "Swaziland",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Sweden",
        "supportEmail": "luminasupport.sweden@dnv.com"
    },
    {
        "countryName": "Switzerland",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "Syrian Arab Republic",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Tahiti",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Taiwan",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "Tajikistan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Tanzania, United Republic of",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Thailand",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Togo",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Tokelau",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Tonga",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Trinidad and Tobago",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Tunisia",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Turkey",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "Turkmenistan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Turks and Caicos Islands",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Tuvalu",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "USA",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Uganda",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Ukraine",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "United Arab Emirates",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "United Kingdom",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "United States Minor Outlying I",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Uruguay",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Uzbekistan",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Vanuatu",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "Venezuela",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "Viet Nam",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "Virgin Islands (British)",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Virgin Islands (U.S.)",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "Wallis and Futuna Islands",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Western Sahara",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Yemen",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "Zambia",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Zimbabwe",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "Saint Helena, Ascension and Tr",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Man (Isle of)",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "Saint Martin (French part)",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "Sint Maarten (Dutch part)",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "Kosovo",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "LS",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "HM",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "CO",
        "supportEmail": "luminasupport.chile@dnv.com"
    },
    {
        "countryName": "AS",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "TR",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "SX",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "LR",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "GD",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "AG",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "AZ",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "TG",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "NP",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "CY",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "MH",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "ML",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "VC",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "MP",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "VE",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "VI",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "NO",
        "supportEmail": "luminasupport.norway@dnv.com"
    },
    {
        "countryName": "PA",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "SV",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "KY",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "LT",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "TC",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "IN",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "SH",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "BT",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "CK",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "FK",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "ET",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "GN",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "GP",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "MS",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "MW",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "CC",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "BR",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "LI",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "NI",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "PF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "NZ",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "OM",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "GW",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "UG",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "LB",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "SZ",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "AM",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "ME",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "BB",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "TK",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "MF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "PT",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "AL",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "RW",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "EH",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "AI",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "MQ",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "BG",
        "supportEmail": "luminasupport.bulgaria@dnv.com"
    },
    {
        "countryName": "ST",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "EC",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "NR",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "NF",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "PG",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "BH",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "CN",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "SD",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "UZ",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "BI",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "CL",
        "supportEmail": "luminasupport.chile@dnv.com"
    },
    {
        "countryName": "GA",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "ER",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "TZ",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "ZA",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "PN",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "JE",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "NC",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "SK",
        "supportEmail": "luminasupport.czsk@dnv.com"
    },
    {
        "countryName": "JO",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "GY",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "PS",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "CR",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "QA",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "FJ",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "KH",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "GU",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "WF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "SN",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "GT",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "BM",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "LY",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "XK",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "GG",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "SL",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "US",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "MG",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "MY",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "GI",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "VN",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "BZ",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "UY",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "BE",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "TW",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "DZ",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "NU",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "LC",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "FR",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "CX",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "NA",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "PR",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "BO",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "LV",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "TJ",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "TV",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "RS",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "TO",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "LA",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "CV",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "KI",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "ZM",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "SY",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "NL",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "GE",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "MX",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "ES",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "MV",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "SJ",
        "supportEmail": "luminasupport.norway@dnv.com"
    },
    {
        "countryName": "HR",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "NL",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "SI",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "PL",
        "supportEmail": "luminasupport.poland@dnv.com"
    },
    {
        "countryName": "RO",
        "supportEmail": "luminasupport.romania@dnv.com"
    },
    {
        "countryName": "WS",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "PK",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "ID",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "CM",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "MD",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "DJ",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "SO",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "VG",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "IE",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "CZ",
        "supportEmail": "luminasupport.czsk@dnv.com"
    },
    {
        "countryName": "IS",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "IO",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "MO",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "TH",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "BN",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "GB",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "BJ",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "HN",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "LU",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "CH",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "HT",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "NE",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "MA",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "MC",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "IL",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "UA",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "MZ",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "CF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "FO",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "BD",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "IM",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "HU",
        "supportEmail": "luminasupport.hungary@dnv.com"
    },
    {
        "countryName": "EE",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "MN",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "YE",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "FM",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "TT",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "PW",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "EG",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "CI",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "AO",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "IQ",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "SH",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "FR",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "MU",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "CU",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "PY",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "DK",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "JP",
        "supportEmail": "luminasupport.japan@dnv.com"
    },
    {
        "countryName": "US",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "BY",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "KW",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "SB",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "MM",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "CA",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "GE",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "TN",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "AU",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "GF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "HT",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "BS",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "VA",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "SA",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "MK",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "LK",
        "supportEmail": "luminasupport.india@dnv.com"
    },
    {
        "countryName": "FI",
        "supportEmail": "luminasupport.finlandbaltics@dnv.com"
    },
    {
        "countryName": "KN",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "AW",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "SM",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "GR",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "IM",
        "supportEmail": "luminasupport.uk@dnv.com"
    },
    {
        "countryName": "KR",
        "supportEmail": "luminasupport.korea@dnv.com"
    },
    {
        "countryName": "SG",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "PE",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "MT",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "TF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "KP",
        "supportEmail": "luminasupport.korea@dnv.com"
    },
    {
        "countryName": "KG",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "SR",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "AD",
        "supportEmail": "luminasupport.iberia@dnv.com"
    },
    {
        "countryName": "HK",
        "supportEmail": "luminasupport.gchina@dnv.com"
    },
    {
        "countryName": "GQ",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "GH",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "JM",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "CG",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "SE",
        "supportEmail": "luminasupport.sweden@dnv.com"
    },
    {
        "countryName": "CD",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "CW",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "AE",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "MR",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "BV",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "IT",
        "supportEmail": "luminasupport.italy@dnv.com"
    },
    {
        "countryName": "YT",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "SC",
        "supportEmail": "luminasupport.bnl@dnv.com"
    },
    {
        "countryName": "TD",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "ZW",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "GL",
        "supportEmail": "luminasupport.denmark@dnv.com"
    },
    {
        "countryName": "BF",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "DO",
        "supportEmail": "luminasupport.mexico@dnv.com"
    },
    {
        "countryName": "KZ",
        "supportEmail": "luminasupport.russia@dnv.com"
    },
    {
        "countryName": "PH",
        "supportEmail": "luminasupport.sea@dnv.com"
    },
    {
        "countryName": "BA",
        "supportEmail": "luminasupport.adriatic@dnv.com"
    },
    {
        "countryName": "RE",
        "supportEmail": "luminasupport.france@dnv.com"
    },
    {
        "countryName": "AT",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "AQ",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "AR",
        "supportEmail": "luminasupport.argentina@dnv.com"
    },
    {
        "countryName": "DM",
        "supportEmail": "luminasupport.brazil@dnv.com"
    },
    {
        "countryName": "IR",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "VU",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "NG",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "TM",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "KM",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "TL",
        "supportEmail": "luminasupport.australia@dnv.com"
    },
    {
        "countryName": "BW",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "GM",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "KE",
        "supportEmail": "luminasupport.africa@dnv.com"
    },
    {
        "countryName": "PM",
        "supportEmail": "luminasupport.US@dnv.com"
    },
    {
        "countryName": "DE",
        "supportEmail": "luminasupport.germany@dnv.com"
    },
    {
        "countryName": "AF",
        "supportEmail": "luminasupport.me@dnv.com"
    },
    {
        "countryName": "RU",
        "supportEmail": "luminasupport.russia@dnv.com"
    }
]